module.exports = __webpack_public_path__ + "fonts/OpenSans300italic.6725fc49.eot";